import { InjectionToken } from '@angular/core';

export const REDIRECT = new InjectionToken('REDIRECT');
